import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchCountrySettings } from '../services/countryService';

interface CountryContextType {
  selectedCountry: string;
  setSelectedCountry: (country: string) => void;
  availableCountries: { code: string; name: string }[];
}

const CountryContext = createContext<CountryContextType | undefined>(undefined);

export const useCountry = () => {
  const context = useContext(CountryContext);
  if (!context) {
    throw new Error('useCountry must be used within a CountryProvider');
  }
  return context;
};

export const CountryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedCountry, setSelectedCountry] = useState<string>('NZ');
  const [availableCountries, setAvailableCountries] = useState<{ code: string; name: string }[]>([]);

  useEffect(() => {
    const loadCountries = async () => {
      try {
        const countries = await fetchCountrySettings();
        const activeCountries = countries
          .filter(c => c.is_active)
          .map(c => ({ code: c.country_code, name: c.country_name }));
        setAvailableCountries(activeCountries);
      } catch (error) {
        console.error('Error loading countries:', error);
      }
    };

    loadCountries();
  }, []);

  return (
    <CountryContext.Provider value={{ selectedCountry, setSelectedCountry, availableCountries }}>
      {children}
    </CountryContext.Provider>
  );
};
